export default __webpack_public_path__ + "static/media/Logo-EarthID-white.74fef49f.png";